import { Component } from 'react';

/**
 * ErrorBoundary wraps each page so an unhandled JS error
 * only breaks that page, not the entire app.
 *
 * Usage in Dashboard.js:
 *   <ErrorBoundary>
 *     <PriceChangeAlerts ... />
 *   </ErrorBoundary>
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-32 gap-4 text-center px-8">
          <p className="text-red-400 font-semibold text-lg">Something went wrong on this page</p>
          <p className="text-emerald-600 text-sm max-w-md">
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            className="mt-2 px-5 py-2 bg-emerald-700 hover:bg-emerald-600 text-white text-sm font-medium rounded-xl transition-colors"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
